export default "__VITE_ASSET__BU3C1vbg__"